import { differenceInDays, set } from 'date-fns';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datedifference'
})
export class DatedifferencePipe implements PipeTransform {

  transform(value: Date, startDate: Date, endDate: Date): string {
    if(!startDate || !endDate){
      return '';
    }
    const tempStartDate = new Date(startDate.getFullYear(),startDate.getMonth(),startDate.getDate() );
    const dateStartDateDifference = differenceInDays(value, tempStartDate);
    if(dateStartDateDifference === 0){
      return 'date-picker-compare-start'
    }
    const tempEndDate = new Date(endDate.getFullYear(),endDate.getMonth(),endDate.getDate() );
    const dateEndDateDifference = differenceInDays(tempEndDate, value);
    if(dateEndDateDifference === 0){
      return 'date-picker-compare-end'
    }
    if(dateStartDateDifference > 0 && dateEndDateDifference > 0){
      return 'date-picker-compare-middle'
    }
    return '';
  }

}
